import { AsyncStatus } from '@monetize/types/common';
import { Box, Icon, Spinner } from '@chakra-ui/react';
import { MdCheck, MdClose } from 'react-icons/md';

interface AsyncStatusIndicatorProps {
  status: AsyncStatus;
  size?: number;
  color?: string;
}

export const AsyncStatusIndicator = ({
  status,
  size = 16,
  color,
}: AsyncStatusIndicatorProps) => {
  if (status === 'idle') {
    return null;
  }

  return (
    <Box
      position="absolute"
      left="calc(100% + 8px)"
      top="50%"
      transform="translateY(-50%)"
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      {status === 'loading' && (
        <Spinner
          width={`${size}px`}
          height={`${size}px`}
          color={color ?? 'tIndigo.500'}
        />
      )}
      {status === 'success' && (
        <Icon color={color ?? 'tCyan.dark'} boxSize={`${size}px`} asChild>
          <MdCheck />
        </Icon>
      )}
      {status === 'error' && (
        <Icon color={color ?? 'tRed.base'} boxSize={`${size}px`} asChild>
          <MdClose />
        </Icon>
      )}
    </Box>
  );
};
